import React from 'react'
import Header from '../../components/Header/Header';
import DonationDetails from '../../components/DonationDetails/DonationDetails';
import './DonationDetailsPage.css';
function DonationDetailsPage() {
  return (
    <Header activeRoute="/"  class='mainDiv'>
      <DonationDetails/>
    </Header>
  )
}

export default DonationDetailsPage
